module.exports = __webpack_public_path__ + "images/company/rank_medal/selling_agreement_percent_rank/3_f1524d388a6fd0ef7456fd80113685ec.png";